// @ts-nocheck
import { del, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { AddCartAllowanceApiParameter } from "@store/Framework/Types/ApiModels";

const allowanceUrl = "/api/v1/cart/allowance";

export async function addCartAllowance(parameter: AddCartAllowanceApiParameter): Promise<ServiceResult<BaseModel>> {
    try {
        const allowanceModel = await post<BaseModel>(`${allowanceUrl}/update`, parameter.amount as any);
        return {
            successful: true,
            result: allowanceModel,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function removeCartAllowance() {
    try {
        await del(`${allowanceUrl}/remove`);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorMessage,
        };
    }
}
